import { FC } from "react";
import { Flex, Text } from "@chakra-ui/react";
import { Trans } from "~/utils/i18next";

interface Props {
  description: string;
  discountAmount: string;
}

export const DiscountLine: FC<Props> = ({ description, discountAmount }) => {
  return (
    <Flex justify="space-between" mb={4} w="full">
      <Text color="th.blueGreen2" variant="th-body2">
        {description}
      </Text>
      <Text color="th.blueGreen2" variant="th-body2">
        <Trans
          i18nKey="planPayment.promoCode.formattedDiscount"
          values={{ discountAmount }}
        />
      </Text>
    </Flex>
  );
};
